// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2qpp_","ranges":"BmiRanges_ranges__2YaH3"};